import { TIME_FORMATS } from "./constants";

type UserTime = {
  hour: string;
  minute: string;
  meridiem: "AM" | "PM" | null;
};

export function getUserTime(
  timeFormat: string = TIME_FORMATS.TWELVE_HOUR,
): UserTime {
  const now = new Date();
  let hour = now.getHours();
  const minute = now.getMinutes();

  if (timeFormat === TIME_FORMATS.TWELVE_HOUR) {
    const meridiem: "AM" | "PM" = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // Convert to 12-hour format

    return {
      hour: hour.toString().padStart(2, "0"),
      minute: minute.toString().padStart(2, "0"),
      meridiem,
    };
  }

  // 24-hour format
  return {
    hour: hour.toString().padStart(2, "0"),
    minute: minute.toString().padStart(2, "0"),
    meridiem: null,
  };
}

export const formatTime = (timeStr: string) => {
  if (!timeStr) return;
  const [time, meridiem] = timeStr.trim().split(" ");
  const [hour, minute] = time.split(":");

  return {
    hour,
    minute,
    meridiem,
  };
};
